import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import MainDashboard from './pages/main-dashboard';
import ProjectDetailView from './pages/project-detail-view';
import ReportRenderingView from './pages/report-rendering-view';
import AOIReports from './pages/aoi-reports';
import AgentChat from './pages/agent-chat';
import AgentAnalyticsDashboard from './pages/agent-analytics-dashboard';
import AgentTrainingHub from './pages/agent-training-hub';
import DocumentManagementCenter from './pages/document-management-center';
import RealTimeAlertCenter from './pages/real-time-alert-center';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<MainDashboard />} />
        <Route path="/main-dashboard" element={<MainDashboard />} />
        <Route path="/project-detail-view" element={<ProjectDetailView />} />
        <Route path="/report-rendering-view" element={<ReportRenderingView />} />
        <Route path="/aoi-reports" element={<AOIReports />} />
        <Route path="/agent-chat" element={<AgentChat />} />
        <Route path="/agent-analytics-dashboard" element={<AgentAnalyticsDashboard />} />
        <Route path="/agent-training-hub" element={<AgentTrainingHub />} />
        <Route path="/document-management-center" element={<DocumentManagementCenter />} />
        <Route path="/real-time-alert-center" element={<RealTimeAlertCenter />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
